module.exports = __webpack_public_path__ + "static/media/gutgereift_logo.fef8521e.svg";